import { render } from "./Select.vue?vue&type=template&id=398ef4b7&scoped=true&ts=true"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=398ef4b7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398ef4b7"]])

export default __exports__